import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-number-step-input',
  templateUrl: './number-step-input.component.html',
  styleUrls: ['./number-step-input.component.scss'],
})
export class NumberStepInputComponent {
  @Input() control!: FormControl;
  @Input() name!: string;

  constructor() {}

  onIncrement() {
    this.control.setValue(this.control.value + 1);
  }

  onDecrement() {
    if (this.control.value > 0) {
      this.control.setValue(this.control.value - 1);
    }
  }
}
